import React, { useState } from 'react';
import '../css/Reports.css';

const Reports = () => {
  const [selectedReport, setSelectedReport] = useState('user-activity');
  const [dateRange, setDateRange] = useState('7d');
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerateReport = () => {
    setIsGenerating(true);
    // Simulate report generation
    setTimeout(() => {
      setIsGenerating(false);
      alert('Report generated successfully!');
    }, 2000);
  };

  const handleDownloadReport = (format) => {
    alert(`Downloading report in ${format.toUpperCase()} format...`);
  };

  const reports = [
    {
      id: 'user-activity',
      name: 'User Activity Report',
      description: 'Detailed user activity and engagement metrics',
      icon: '👥',
      lastGenerated: '2024-01-15 10:30 AM'
    },
    {
      id: 'system-performance',
      name: 'System Performance Report',
      description: 'System performance metrics and resource usage',
      icon: '⚡',
      lastGenerated: '2024-01-14 02:15 PM'
    },
    {
      id: 'error-logs',
      name: 'Error Logs Report',
      description: 'Application errors and exception logs',
      icon: '🚨',
      lastGenerated: '2024-01-13 09:45 AM'
    },
    {
      id: 'security-audit',
      name: 'Security Audit Report',
      description: 'Security events and access logs',
      icon: '🔒',
      lastGenerated: '2024-01-12 04:20 PM'
    },
    {
      id: 'financial-summary',
      name: 'Financial Summary Report',
      description: 'Revenue and financial performance metrics',
      icon: '💰',
      lastGenerated: '2024-01-11 11:30 AM'
    },
    {
      id: 'custom-report',
      name: 'Custom Report',
      description: 'Create a custom report with specific parameters',
      icon: '📊',
      lastGenerated: 'Never'
    }
  ];

  const recentReports = [
    {
      name: 'User Activity Report - Jan 2024',
      type: 'PDF',
      size: '2.3 MB',
      generated: '2024-01-15 10:30 AM',
      status: 'completed'
    },
    {
      name: 'System Performance Report - Jan 2024',
      type: 'Excel',
      size: '1.8 MB',
      generated: '2024-01-14 02:15 PM',
      status: 'completed'
    },
    {
      name: 'Error Logs Report - Jan 2024',
      type: 'CSV',
      size: '4.1 MB',
      generated: '2024-01-13 09:45 AM',
      status: 'completed'
    }
  ];

  return (
    <div className="reports-content">
      <div className="page-header">
        <div className="header-content">
          <h1>Reports</h1>
          <p>Generate and manage system reports and analytics</p>
        </div>
      </div>

      <div className="reports-container">
        <div className="reports-sidebar">
          <div className="sidebar-section">
            <h3>Report Types</h3>
            <div className="report-list">
              {reports.map(report => (
                <button
                  key={report.id}
                  className={`report-item ${selectedReport === report.id ? 'active' : ''}`}
                  onClick={() => setSelectedReport(report.id)}
                >
                  <div className="report-icon">{report.icon}</div>
                  <div className="report-info">
                    <div className="report-name">{report.name}</div>
                    <div className="report-description">{report.description}</div>
                    <div className="report-last-generated">
                      Last: {report.lastGenerated}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="reports-panel">
          <div className="report-configuration">
            <div className="config-header">
              <h2>{reports.find(r => r.id === selectedReport)?.name}</h2>
              <p>{reports.find(r => r.id === selectedReport)?.description}</p>
            </div>

            <div className="config-options">
              <div className="config-group">
                <label htmlFor="dateRange">Date Range</label>
                <select
                  id="dateRange"
                  value={dateRange}
                  onChange={(e) => setDateRange(e.target.value)}
                >
                  <option value="7d">Last 7 days</option>
                  <option value="30d">Last 30 days</option>
                  <option value="90d">Last 90 days</option>
                  <option value="1y">Last year</option>
                  <option value="custom">Custom range</option>
                </select>
              </div>

              <div className="config-group">
                <label>Include Data</label>
                <div className="checkbox-group">
                  <label className="checkbox-item">
                    <input type="checkbox" defaultChecked />
                    <span>User activity</span>
                  </label>
                  <label className="checkbox-item">
                    <input type="checkbox" defaultChecked />
                    <span>System metrics</span>
                  </label>
                  <label className="checkbox-item">
                    <input type="checkbox" />
                    <span>Error logs</span>
                  </label>
                  <label className="checkbox-item">
                    <input type="checkbox" />
                    <span>Security events</span>
                  </label>
                </div>
              </div>

              <div className="config-actions">
                <button 
                  className="generate-btn"
                  onClick={handleGenerateReport}
                  disabled={isGenerating}
                >
                  {isGenerating ? 'Generating...' : 'Generate Report'}
                </button>
              </div>
            </div>
          </div>

          <div className="recent-reports">
            <h3>Recent Reports</h3>
            <div className="reports-list">
              {recentReports.map((report, index) => (
                <div key={index} className="report-file">
                  <div className="file-info">
                    <div className="file-name">{report.name}</div>
                    <div className="file-meta">
                      <span className="file-type">{report.type}</span>
                      <span className="file-size">{report.size}</span>
                      <span className="file-date">{report.generated}</span>
                    </div>
                  </div>
                  <div className="file-actions">
                    <button 
                      className="download-btn"
                      onClick={() => handleDownloadReport(report.type.toLowerCase())}
                    >
                      Download
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports; 